import { render, staticRenderFns } from "./LevelUpButton.vue?vue&type=template&id=0c089304&scoped=true&lang=pug&"
import script from "./LevelUpButton.vue?vue&type=script&lang=ts&"
export * from "./LevelUpButton.vue?vue&type=script&lang=ts&"
import style0 from "./LevelUpButton.vue?vue&type=style&index=0&id=0c089304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c089304",
  null
  
)

export default component.exports